import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Input } from "~/components/input";

import type { LabelFormState } from "./form-state";

export interface WidgetYAxisLabelProps {
	className?: string;
	disabled?: boolean;
	name: string;
	label: LabelFormState;
}

export const WidgetYAxisLabel: React.FC<WidgetYAxisLabelProps> = ({ className, disabled, name, label }) => {
	const monitor = useMonitor();

	return (
		<Input
			className={className}
			disabled={disabled}
			name={name}
			onChange={(event) => label.setInput(event.target.value)}
			placeholder="Default"
			value={label.getInput(monitor)}
		/>
	);
};
